<template>
  <v-layout wrap class="px-0 mx-0" style="position: relative">
    <span class="date-label" :style="isFutureDate?'color:red;':''">{{ label }}</span>
    <v-layout class="px-1" row
              :style="isFutureDate? 'border-style: solid;border-width: thin;border-radius: 5px;border-color:red':'border-style: solid;border-width: thin;border-radius: 5px;'"
              wrap>
      <v-flex xs4 class="pa-1">
        <v-autocomplete
            :items="days_array"
            class="custom"
            flat
            solo
            hide-details
            label="Day "
            style="padding: 0;"
            v-model="dob.day"
            :readonly="readonly"
        />
      </v-flex>

      <v-flex style="padding-right: 8px;" xs4 class="pa-1">
        <v-autocomplete
            :items="months"
            class="custom"
            flat
            solo
            hide-details
            item-text="value"
            item-value="number"
            label="Month "
            style="padding: 0;"
            v-model="dob.month"
            :readonly="readonly"
        />
      </v-flex>
      <v-flex style="padding-right: 8px;" xs4 class="pa-1">
        <v-autocomplete
            :items="years"
            class="custom"
            flat
            solo
            hide-details
            label="Year "
            style="padding: 0;"
            type="text"
            v-model="dob.year"
            :readonly="readonly"
        />
      </v-flex>
    </v-layout>
    <span v-if="isFutureDate" style="color:red;">
              Date cannot be future
        </span>
  </v-layout>
</template>

<script>
import {validationMixin} from "../mixins/validationMixin";
import moment from "moment";
//
export default {
  name: "NewDatePicker",
  props: ['label', 'value', 'maxYear', 'minYear', 'watchValue', 'readonly', 'validateFutureDate', 'expiryDate'],
  data() {
    return {
      dob: {
        year: null,
        month: null,
        day: null
      },
      years: [],
      days_array: [],
      months: [
        {
          number: '01',
          value: 'JAN'
        },
        {
          number: '02',
          value: 'FEB'
        },
        {
          number: '03',
          value: 'MAR'
        },
        {
          number: '04',
          value: 'APR'
        },
        {
          number: '05',
          value: 'MAY'
        },
        {
          number: '06',
          value: 'JUN'
        },
        {
          number: '07',
          value: 'JUL'
        },
        {
          number: '08',
          value: 'AUG'
        },
        {
          number: '09',
          value: 'SEP'
        },
        {
          number: '10',
          value: 'OCT'
        },
        {
          number: '11',
          value: 'NOV'
        },
        {
          number: '12',
          value: 'DEC'
        }

      ],
      validations: {
        date: {
          isFutureDate() {
            if (this.validateFutureDate && moment(this.year_value).format('Y-m-d') !== "Invalid date" && !moment(this.year_value).isBefore(moment.now())) {
              return true;
            }
          }
        },
      },
    }
  },
  mixins: [validationMixin],
  computed: {
    year_value() {
      return this.dob.year + '-' + this.dob.month + '-' + this.dob.day;
    },
    isFutureDate() {
      if (this.validateFutureDate && moment(this.year_value).format('Y-m-d') !== "Invalid date" && !moment(this.year_value).isBefore(moment.now())) {
        return true;
      }
    }
  },
  watch: {
    year_value() {
      this.$emit('input', this.year_value)
    },
    value() {
      if (this.value && this.watchValue) {
        this.dob.year = parseInt(this.value.substr(0, 4));
        this.dob.month = this.value.substr(5, 2);
        this.dob.day = this.value.substr(8, 2);
      }
    }
  },
  mounted() {
    let currentYear = new Date().toISOString().substr(0, 4);
    currentYear = parseInt(currentYear);
    let years_array = [];
    let maximumYear = currentYear + 12;
    let minimumYear = 2000;
    if (this.maxYear) {
      maximumYear = this.maxYear;
    }
    if (this.minYear) {
      minimumYear = this.minYear;
    }
    let days = 31;
    for (let i = minimumYear; i <= maximumYear; i++) {
      years_array.push(i);
    }
    years_array = years_array.reverse();
    this.years = years_array;
    const days_array = [];

    for (let i = 1; i <= days; i++) {
      let value = i < 10 ? ('0' + i) : i.toString();
      days_array.push(value)
    }
    this.days_array = days_array;
    if (this.value) {
      this.dob.year = parseInt(this.value.substr(0, 4));
      this.dob.month = this.value.substr(5, 2);
      this.dob.day = this.value.substr(8, 2);
    }
  }
}
</script>

<style>
.custom.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none;
  padding-top: 0;
  padding-bottom: -40px;
}

.custom.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none;
  padding-top: 0;
  padding-bottom: -40px;
}

.date-label {
  position: absolute;
  z-index: 4;
  margin-top: -10px;
  background: white;
  padding-left: 3px;
  padding-right: 3px;

}
</style>

